// @flow
import client from '../../client'

// Constants
export const CHECK_STATE_ENDPOINT = '/corporate/user/check_state/'

// Types
export type State = {
  do_redirect: boolean,
  redirect_to: string,
}

/**
 * Check user's state
 * If the user has an invalid session a new token is requested
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const checkState = (data: {
  email: string,
  domain: string,
}): Promise<State> => client.get(CHECK_STATE_ENDPOINT, { query: data })

export default checkState
